// firebasePlugin.js
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';

export const firebasePlugin = {
  install: (app) => {
    const firebaseConfig = {
          apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
          authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
          projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
          storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
          appId: process.env.VUE_APP_FIREBASE_APP_ID,
          measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
    };

    const firebaseApp = initializeApp(firebaseConfig);
    const auth = getAuth(firebaseApp);
    const db = getFirestore(firebaseApp);

    // Add an auth state change listener
    onAuthStateChanged(auth, (user) => {
      //app.config.globalProperties.$currentUser_Auth = user;
      
      // Set global auth value to null if user is signed out
      if (!user) {
        app.config.globalProperties.$currentUser_Auth = null;
        // console.log("Auth Changedd Signed out", user);
      }
      else{
        app.config.globalProperties.$currentUser_Auth = user;
        // console.log("Auth Changedd Signed In", user);
      }


    });
    

    app.config.globalProperties.$auth = auth;
    app.config.globalProperties.$db = db;
  }
};
